<template>
    <div id="app-layout">
        <router-view></router-view>
    </div>
</template>

<script>
//import MainNavigation from './main-navigation.vue';

import settings from "./settings";
import { mapActions } from "vuex";

export default {
    name: "layout",
    data() {
        return {};
    },
    mounted() {
        window.fbAsyncInit = function() {
            FB.init({
                appId: settings.facebook_app_id,
                autoLogAppEvents: true,
                xfbml: true,
                status: true,
                cookie: true,
                version: "v3.3"
            });
        };
    },
    methods: {
        ...mapActions(["get_logged_in_user"])
    }
};
</script>

<style scoped></style>
